/* Soulyshine — Build Your Charm Bracelet popup (under Add to cart). See snippets/ss-bracelet-popup.liquid. */
(function () {
  'use strict';
  if (window.__ssBraceletPopup) return;
  var host = document.querySelector('[data-ss-bbp]');
  if (!host) return;
  window.__ssBraceletPopup = true;

  var config;
  try { config = JSON.parse(host.querySelector('[data-ss-bbp-config]').textContent); } catch (e) { return; }
  var root = (config.root || '/').replace(/\/?$/, '/');
  var copy = config.copy || {};
  var MAX = Number(config.maxCharms) || 8;
  var MAX_SLOTS = 6; // theme tiles the shopper can open (search tile is separate)

  var els = {
    modal: host.querySelector('[data-ss-bbp-modal]'),
    body: host.querySelector('[data-ss-bbp-body]'),
    stage: host.querySelector('[data-ss-bbp-stage]'),
    chain: host.querySelector('[data-ss-bbp-chain]'),
    hang: host.querySelector('[data-ss-bbp-hang]'),
    hint: host.querySelector('[data-ss-bbp-hint]'),
    braceletMeta: host.querySelector('[data-ss-bbp-bracelet-meta]'),
    braceletMat: host.querySelector('[data-ss-bbp-bracelet-material]'),
    tiles: host.querySelector('[data-ss-bbp-tiles]'),
    loading: host.querySelector('[data-ss-bbp-loading]'),
    summary: host.querySelector('[data-ss-bbp-summary]'),
    add: host.querySelector('[data-ss-bbp-add]'),
    error: host.querySelector('[data-ss-bbp-error]'),
    preview: host.querySelector('.ss-bbp__preview'),
    promo: host.querySelector('[data-ss-bbp-promo]'),
    promoText: host.querySelector('[data-ss-bbp-promo-text]'),
    pin: host.querySelector('[data-ss-bbp-pin]'),
    pinChain: host.querySelector('[data-ss-bbp-pin-chain]'),
    pinHang: host.querySelector('[data-ss-bbp-pin-hang]'),
    pinCount: host.querySelector('[data-ss-bbp-pin-count]'),
    pinPromo: host.querySelector('[data-ss-bbp-pin-promo]'),
    searchForm: host.querySelector('[data-ss-bbp-search-form]'),
    searchInput: host.querySelector('[data-ss-bbp-search-input]'),
    searchStatus: host.querySelector('[data-ss-bbp-search-status]'),
    searchResults: host.querySelector('[data-ss-bbp-search-results]')
  };
  var promoTypes = String(config.promo.types || 'Charm').split(/[,\n]/).map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  var promoTotal = Number(config.promo.total) || 3;

  // The buy-buttons block sits in a sticky column (its own stacking context, under the sticky header): the modal
  // must live on <body> to cover the page.
  document.body.appendChild(els.modal);

  var state = {
    open: false, loaded: null, catalog: null, bracelet: null, cart: null,
    braceletMat: '', braceletTouched: false,
    slots: [config.fixedThemes[0], config.fixedThemes[1], null], // tile 4 = search (static markup)
    picks: [], // { charm, theme, m (override or null) }
    search: { query: '', items: [], hidden: 0, loading: false, error: '', requestId: 0 },
    full: {}, // theme handle → true once the full (30) list is loaded
    busy: false
  };

  // ----- helpers
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(v) { return String(v == null ? '' : v).trim().replace(/\s+/g, ' ').toLowerCase(); }
  function money(cents) {
    var amount = Number(cents) / 100;
    var format = config.moneyFormat || '${{amount}}';
    var text = /amount_no_decimals/.test(format) ? String(Math.round(amount)) : amount.toFixed(2);
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, text).replace(/<[^>]+>/g, '');
  }
  function img(src, width) {
    if (!src) return '';
    src = String(src).replace(/^\/\//, 'https://');
    if (/[?&]width=/.test(src)) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + (width || 240);
  }
  function fetchJson(url, options) {
    return fetch(url, Object.assign({ headers: { Accept: 'application/json' } }, options || {})).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || ('Request failed (' + r.status + ')')); e.status = r.status; throw e; }
        return data;
      });
    });
  }
  function showError(msg) { els.error.textContent = msg || ''; els.error.hidden = !msg; }
  function pic(src, cls) { return '<span class="' + cls + '" style="background-image:url(' + esc(JSON.stringify(String(src || ''))) + ')"></span>'; }

  // ----- materials
  // Map a wanted material onto the names a product actually offers (same rules as the cart upsell / set logic).
  function materialFor(want, names) {
    if (!names.length) return null;
    if (names.indexOf(want) !== -1) return want;
    var m = norm(want);
    function pick(re) { for (var i = 0; i < names.length; i++) if (re.test(names[i])) return names[i]; return null; }
    if (/rose/.test(m)) return pick(/rose/i) || pick(/gold vermeil/i) || pick(/gold/i);
    if (/white gold/.test(m)) return pick(/white gold/i) || pick(/sterling/i);
    if (/vermeil|solid gold|10k|14k/.test(m)) return pick(/^18k gold vermeil/i) || pick(/gold vermeil/i) || pick(/gold/i);
    if (/sterling/.test(m)) return pick(/sterling/i);
    if (/gold plated/.test(m)) return pick(/^18k gold plated/i) || pick(/gold plated/i) || pick(/gold/i);
    return pick(/silver plated/i) || pick(/silver/i) || names[0];
  }
  function finishOf(mat) {
    var m = norm(mat);
    if (/rose/.test(m)) return 'rose';
    if (/white gold/.test(m)) return 'silver';
    if (/gold|vermeil/.test(m)) return 'gold';
    return 'silver';
  }
  function braceletVariants() { return ((state.bracelet && state.bracelet.variants) || []).filter(function (v) { return v.available !== false; }); }
  function braceletVariant() {
    var vs = braceletVariants();
    for (var i = 0; i < vs.length; i++) if ((vs[i].option1 || vs[i].title) === state.braceletMat) return vs[i];
    return vs[0] || null;
  }
  function charmVariant(pick) {
    var names = pick.charm.variants.map(function (v) { return v.m; });
    var want = materialFor(pick.m || state.braceletMat, names);
    for (var i = 0; i < pick.charm.variants.length; i++) if (pick.charm.variants[i].m === want) return pick.charm.variants[i];
    return pick.charm.variants[0];
  }
  function charmImage(charm, mat) {
    var names = charm.variants.map(function (v) { return v.m; });
    var want = materialFor(mat, names);
    for (var i = 0; i < charm.variants.length; i++) if (charm.variants[i].m === want && charm.variants[i].img) return charm.variants[i].img;
    return charm.img || (charm.variants[0] && charm.variants[0].img) || '';
  }

  // ----- cart
  function cartItems() { return ((state.cart && state.cart.items) || []).filter(function (i) { return Number(i.quantity) > 0; }); }
  function braceletInCart() { return cartItems().some(function (i) { return i.handle === config.bracelet.handle; }); }
  function announce(cart) {
    var detail = { source: 'ss-bracelet-popup', cart: cart, cartUpdatedAt: Date.now() };
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('soulyshine:cart:updated', { detail: detail }));
  }
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) { /* fall through */ } }
    window.location.href = root + 'cart';
  }

  // ----- data
  function load() {
    if (state.loaded) return state.loaded;
    // Studio serves the live catalog (refreshed every 12 h); the theme asset is a snapshot used when Studio is unreachable.
    var catalog = (config.catalogSource === 'asset' && config.catalogFallback
      ? fetchJson(config.catalogFallback)
      : fetchJson(config.studio.replace(/\/$/, '') + '/p/bb/catalog', { mode: 'cors' })
        .catch(function () { if (!config.catalogFallback) throw new Error('catalog'); return fetchJson(config.catalogFallback); }))
      .then(function (c) { state.catalog = c; });
    var bracelet = fetchJson(root + 'products/' + encodeURIComponent(config.bracelet.handle) + '.js').then(function (p) {
      state.bracelet = p;
      var names = braceletVariants().map(function (v) { return v.option1 || v.title; });
      if (!state.braceletMat) state.braceletMat = materialFor(config.product.material || '', names) || names[0] || '';
    });
    var cart = fetchJson(root + 'cart.js').then(function (c) { state.cart = c; }).catch(function () {});
    state.loaded = Promise.all([catalog, bracelet, cart]).then(function () { render(); }, function (e) {
      state.loaded = null;
      els.loading.textContent = 'Could not load the charms right now — please try again in a moment.';
      throw e;
    });
    return state.loaded;
  }

  // ----- picks (each pick has qty; the preview shows one drop per unit)
  function pickUnits() { return state.picks.slice(); }
  function pickCount() { return pickUnits().length; }
  function findPick(id) { for (var i = 0; i < state.picks.length; i++) if (String(state.picks[i].charm.id) === String(id)) return state.picks[i]; return null; }
  function togglePick(id, themeHandle) {
    var existing = findPick(id);
    if (existing) { state.picks = state.picks.filter(function (p) { return p !== existing; }); render(true); return; }
    if (pickCount() >= MAX) { showError('You can add up to ' + MAX + ' charms per set.'); return; }
    var list = themeHandle === 'search' ? state.search.items : (state.catalog.charms[themeHandle] || []);
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) { state.picks.push({ charm: list[i], theme: themeHandle, m: null }); break; }
    showError('');
    render(true);
  }
  // Buy N get 1 free (Shopify automatic discount): estimate over cart items + this set, cheapest of every group free.
  function promoEligible() {
    var prices = [];
    if (config.promo.enabled) {
      cartItems().forEach(function (i) { if (promoTypes.indexOf(norm(i.product_type)) !== -1) for (var q = 0; q < Number(i.quantity); q++) prices.push(Number(i.price)); });
      var bv = braceletVariant();
      if (bv && !braceletInCart() && promoTypes.indexOf('bracelet') !== -1) prices.push(Number(bv.price));
      pickUnits().forEach(function (p) { prices.push(charmVariant(p).p); });
    }
    prices.sort(function (a, b) { return a - b; });
    var groups = Math.floor(prices.length / promoTotal);
    var free = 0; for (var i = 0; i < groups; i++) free += prices[i];
    return { count: prices.length, missing: groups ? 0 : Math.max(0, promoTotal - prices.length), free: free, inSet: pickCount() + ((braceletVariant() && !braceletInCart()) ? 1 : 0) };
  }
  function totals() {
    var charms = 0;
    pickUnits().forEach(function (p) { charms += charmVariant(p).p; });
    var bv = braceletVariant();
    var bracelet = (!braceletInCart() && bv) ? Number(bv.price) : 0;
    var promo = promoEligible();
    // only the part of the estimated discount this set can claim (never more than the set's own lowest-priced items)
    var setPrices = pickUnits().map(function (p) { return charmVariant(p).p; }); if (bracelet) setPrices.push(bracelet);
    setPrices.sort(function (a, b) { return a - b; });
    var cap = 0; for (var i = 0; i < Math.min(setPrices.length, Math.floor(promo.count / promoTotal)); i++) cap += setPrices[i];
    var free = Math.min(promo.free, cap);
    return { charms: charms, bracelet: bracelet, total: charms + bracelet, free: free, afterPromo: charms + bracelet - free, promo: promo };
  }

  // ----- render
  function renderPromo() {
    if (!config.promo.enabled) return;
    var pr = promoEligible();
    var text;
    if (pr.count === 0) text = esc(config.promo.heading) + ' <strong>' + esc(config.promo.pill) + '</strong> — applied automatically at checkout.';
    else if (pr.missing > 0) text = 'Add <strong>' + pr.missing + ' more</strong> — the lowest-priced item is free.';
    else {
      var groups = Math.floor(pr.count / promoTotal), rem = pr.count % promoTotal;
      text = '<strong>' + (groups > 1 ? 'Get ' + groups + ' Free' : esc(config.promo.pill)) + '</strong> · ' + (groups > 1 ? groups + ' lowest-priced items free' : 'lowest-priced item free') + ': −' + esc(money(pr.free)) + ' at checkout.'
        + (rem > 0 ? ' Add ' + (promoTotal - rem) + ' more for another free one.' : '');
    }
    if (els.promoText) els.promoText.innerHTML = text;
    if (els.promo) {
      els.promo.classList.toggle('is-done', pr.missing === 0 && pr.count > 0);
      var dots = els.promo.querySelectorAll('.ss-bbp__dots li');
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-filled', i < (pr.count % promoTotal === 0 && pr.count > 0 ? promoTotal : pr.count % promoTotal));
    }
    if (els.pinPromo) els.pinPromo.textContent = pr.missing > 0 ? 'Add ' + pr.missing + ' more → 1 free' : (pr.count ? Math.floor(pr.count / promoTotal) + ' free ✓ −' + money(pr.free) : '');
  }
  function renderPreview() {
    var fin = finishOf(state.braceletMat);
    var chainUrl = (config.chains && config.chains[fin]) || config.chain;
    els.chain.className = 'ss-bbp__chain ss-bbp__chain--' + fin;
    els.chain.style.backgroundImage = 'url(' + JSON.stringify(chainUrl) + ')';
    if (els.pinChain) { els.pinChain.className = 'ss-bbp__chain ss-bbp__pin-chain ss-bbp__chain--' + fin; els.pinChain.style.backgroundImage = 'url(' + JSON.stringify(chainUrl) + ')'; }
    var trigChain = host.querySelector('.ss-bbp__trigger-chain'); if (trigChain) trigChain.style.backgroundImage = 'url(' + JSON.stringify(chainUrl) + ')';
    var units = pickUnits();
    var n = units.length;
    els.hint.hidden = n > 0;
    els.stage.classList.toggle('has-charms', n > 0);
    if (els.pinHang) els.pinHang.innerHTML = units.map(function (p, i) {
      var left = ((i + 1) / (n + 1) * 100).toFixed(2) + '%';
      return '<span class="ss-bbp__drop ss-bbp__drop--mini" style="left:' + left + '">' + pic(img(charmImage(p.charm, charmVariant(p).m), 120), 'ss-bbp__drop-img') + '</span>';
    }).join('');
    if (els.pinCount) els.pinCount.textContent = n ? n + (n === 1 ? ' charm' : ' charms') + ' · ' + money(totals().afterPromo) : 'No charms yet';
    renderPromo();
    els.hang.innerHTML = units.map(function (p, i) {
      var left = ((i + 1) / (n + 1) * 100).toFixed(2) + '%';
      var v = charmVariant(p);
      return '<button type="button" class="ss-bbp__drop" style="left:' + left + '" data-ss-bbp-pick="' + esc(p.charm.id) + '" data-theme="' + esc(p.theme) + '" title="' + esc(p.charm.name + ' · ' + v.m + ' — tap to remove') + '" aria-label="Remove ' + esc(p.charm.name) + '">'
        + '<span class="ss-bbp__drop-ring"></span>' + pic(img(charmImage(p.charm, v.m), 160), 'ss-bbp__drop-img') + '<span class="ss-bbp__drop-x" aria-hidden="true">&times;</span></button>';
    }).join('');
  }
  function renderBracelet() {
    var vs = braceletVariants();
    var current = braceletVariant();
    els.braceletMat.innerHTML = vs.map(function (v) { var n = v.option1 || v.title; return '<option value="' + esc(n) + '"' + (n === state.braceletMat ? ' selected' : '') + '>' + esc(n) + ' · ' + esc(money(v.price)) + '</option>'; }).join('');
    els.braceletMeta.textContent = braceletInCart() ? copy.inCart : (current ? money(current.price) + ' · ' + current.title : '');
    els.braceletMat.disabled = braceletInCart();
  }
  function cardHtml(charm, theme) {
    var pick = findPick(charm.id);
    var mat = pick ? (pick.m || state.braceletMat) : state.braceletMat;
    var names = charm.variants.map(function (v) { return v.m; });
    var eff = materialFor(mat, names);
    var v = null; for (var i = 0; i < charm.variants.length; i++) if (charm.variants[i].m === eff) v = charm.variants[i];
    v = v || charm.variants[0];
    var full = !pick && pickCount() >= MAX;
    return '<div class="ss-bbp__card' + (pick ? ' is-picked' : '') + '" data-ss-bbp-card="' + esc(charm.id) + '">'
      + '<button type="button" class="ss-bbp__card-pic" data-ss-bbp-pick="' + esc(charm.id) + '" data-theme="' + esc(theme) + '" aria-label="' + esc((pick ? 'Remove ' : 'Select ') + charm.title) + '">' + pic(img(charmImage(charm, eff), 300), 'ss-bbp__card-img') + '<span class="ss-bbp__card-check" aria-hidden="true">✓</span></button>'
      + '<button type="button" class="ss-bbp__zoom" data-ss-bbp-zoom="' + esc(charm.id) + '" data-theme="' + esc(theme) + '" aria-label="' + esc('See ' + charm.name + ' up close') + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4-4M11 8v6M8 11h6"/></svg></button>'
      + '<button type="button" class="ss-bbp__card-text" data-ss-bbp-pick="' + esc(charm.id) + '" data-theme="' + esc(theme) + '" aria-label="' + esc((pick ? 'Remove ' : 'Select ') + charm.title) + '">'
      + '<span class="ss-bbp__card-name" title="' + esc(charm.title) + '">' + esc(charm.name) + '</span>'
      + '<span class="ss-bbp__card-price">' + esc(money(v.p)) + '</span></button>'
      + '<label class="ss-bbp__select ss-bbp__select--sm"><span class="visually-hidden">Material</span><select data-ss-bbp-charm-mat="' + esc(charm.id) + '" data-theme="' + esc(theme) + '">'
      + charm.variants.map(function (x) { return '<option value="' + esc(x.m) + '"' + (x.m === eff ? ' selected' : '') + '>' + esc(x.m) + '</option>'; }).join('')
      + '</select></label>'

      + '</div>';
  }
  function loadMore(handle) {
    if (!config.themeUrl || state.full[handle]) return;
    var btn = els.tiles.querySelector('[data-ss-bbp-more="' + handle + '"]'); if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetchJson(config.themeUrl + '?handle=' + encodeURIComponent(handle), { mode: 'cors' }).then(function (data) {
      if (data && data.items && data.items.length) state.catalog.charms[handle] = data.items;
      state.full[handle] = true;
      var row = btn && btn.closest('.ss-bbp__row'); var scrollLeft = row ? row.scrollLeft : 0;
      render();
      var row2 = els.tiles.querySelector('[data-slot="' + state.slots.indexOf(handle) + '"] .ss-bbp__row'); if (row2) row2.scrollLeft = scrollLeft;
    }).catch(function () { state.full[handle] = true; if (btn) btn.remove(); });
  }
  function themeTitle(handle) {
    var t = (state.catalog.themes || []).filter(function (x) { return x.handle === handle; })[0];
    return t ? t.title : handle;
  }
  function renderTiles() {
    if (!state.catalog) return;
    var all = state.catalog.themes || [];
    els.tiles.innerHTML = state.slots.map(function (handle, i) {
      var head = '<label class="ss-bbp__select ss-bbp__select--theme"><span class="visually-hidden">Theme</span><select data-ss-bbp-theme="' + i + '">'
        + '<option value=""' + (handle ? '' : ' selected') + '>' + esc(copy.pickTheme) + '</option>'
        + all.map(function (t) {
          var used = state.slots.indexOf(t.handle) !== -1 && t.handle !== handle;
          return '<option value="' + esc(t.handle) + '"' + (t.handle === handle ? ' selected' : '') + (used ? ' disabled' : '') + '>' + esc(t.title) + ' (' + t.count + ')</option>';
        }).join('')
        + '</select></label>';
      var list = handle ? (state.catalog.charms[handle] || []) : [];
      var themeMeta = handle ? (state.catalog.themes || []).filter(function (t) { return t.handle === handle; })[0] : null;
      var canMore = handle && !state.full[handle] && themeMeta && themeMeta.count > list.length && config.themeUrl;
      var body = handle
        ? (list.length ? '<div class="ss-bbp__row">' + list.map(function (c) { return cardHtml(c, handle); }).join('')
          + (canMore ? '<button type="button" class="ss-bbp__more" data-ss-bbp-more="' + esc(handle) + '"><span class="ss-bbp__more-n">+' + (Math.min(themeMeta.count, Number(state.catalog.perTheme) || 30) - list.length) + '</span><span>more</span></button>' : '')
          + '</div>' : '<p class="ss-bbp__tile-empty">No charms in this theme yet.</p>')
        : '<p class="ss-bbp__tile-empty">Choose a theme to see its 10 best-selling charms.</p>';
      return '<section class="ss-bbp__tile' + (handle ? '' : ' is-empty') + '" data-slot="' + i + '"><header class="ss-bbp__tile-head">' + head + '</header>' + body + '</section>';
    }).join('') + (state.slots.length < MAX_SLOTS
      ? '<button type="button" class="ss-bbp__add-slot" data-ss-bbp-add-slot>+ Add another theme <span>— or search below</span></button>'
      : '');
  }
  function renderFooter() {
    var t = totals();
    var n = pickCount();
    var parts = [];
    if (!braceletInCart() && braceletVariant()) parts.push(esc(config.bracelet.label) + ' ' + esc(money(t.bracelet)));
    else parts.push(esc(copy.inCart));
    if (n) parts.push(n + (n === 1 ? ' charm ' : ' charms ') + esc(money(t.charms)));
    if (n && t.free > 0) { var g = Math.floor(t.promo.count / promoTotal); parts.push('<em class="ss-bbp__free">' + (g > 1 ? 'Get ' + g + ' Free' : esc(config.promo.pill)) + ' −' + esc(money(t.free)) + '</em>'); }
    els.summary.innerHTML = '<span>' + parts.join(' · ') + '</span>' + (n ? '<strong>' + (t.free > 0 ? '<s>' + esc(money(t.total)) + '</s> ' : 'Total ') + esc(money(t.afterPromo)) + '</strong>' : '');
    els.add.disabled = !n || state.busy;
    els.add.textContent = state.busy ? 'Adding…' : (n ? copy.cta + ' · ' + money(t.afterPromo) : copy.ctaEmpty);
  }
  // Pick / unpick only touches the card's state (a full re-render would reload every charm image and flicker).
  function updateCards() {
    var full = pickCount() >= MAX;
    var cards = els.modal.querySelectorAll('[data-ss-bbp-card]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var pick = findPick(card.getAttribute('data-ss-bbp-card'));
      card.classList.toggle('is-picked', !!pick);
      var picBtn = card.querySelector('.ss-bbp__card-pic');
      if (picBtn) { picBtn.disabled = !pick && full; picBtn.setAttribute('aria-label', (pick ? 'Remove ' : 'Select ') + (picBtn.getAttribute('aria-label') || '').replace(/^(Remove|Select) /, '')); }
      var sel = card.querySelector('[data-ss-bbp-charm-mat]');
      if (sel && pick && pick.m && sel.value !== pick.m) sel.value = pick.m;
    }
  }
  function renderDemo() {
    if (!state.catalog) return;
    var slots = host.querySelectorAll('[data-demo-theme]');
    for (var i = 0; i < slots.length; i++) {
      var list = state.catalog.charms[slots[i].getAttribute('data-demo-theme')] || [];
      var c = list[0]; if (!c) continue;
      var el = slots[i].querySelector('.ss-bbp__tcharm');
      el.style.backgroundImage = 'url(' + JSON.stringify(img(charmImage(c, state.braceletMat || config.product.material || 'Silver Plated'), 160)) + ')';
      slots[i].classList.add('is-filled');
    }
  }
  function render(light) {
    renderDemo();
    if (!state.catalog || !state.bracelet) return;
    els.loading.hidden = true;
    renderPreview();
    renderBracelet();
    if (light && els.tiles.querySelector('[data-ss-bbp-card]')) updateCards(); else { renderTiles(); renderSearch(); }
    renderFooter();
  }

  // ----- search (same engine + log as the storefront search bar, via Studio)
  function visitorId() {
    var key = 'ss-search-visitor-v1', life = 90 * 86400000, now = Date.now();
    var stores = [['browser', window.localStorage], ['session', window.sessionStorage]];
    for (var i = 0; i < stores.length; i++) {
      try {
        var st = stores[i][1]; if (!st) continue;
        var prev = JSON.parse(st.getItem(key) || 'null');
        if (prev && /^[a-f0-9-]{36}$/.test(prev.id) && prev.expires > now) return { id: prev.id, scope: stores[i][0] };
        var id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : null; if (!id) return null;
        st.setItem(key, JSON.stringify({ id: id, expires: now + life })); return { id: id, scope: stores[i][0] };
      } catch (e) { /* storage blocked */ }
    }
    return null;
  }
  function renderSearch() {
    if (!els.searchResults) return;
    var sr = state.search;
    if (sr.loading) { els.searchStatus.textContent = 'Searching…'; els.searchResults.innerHTML = '<div class="ss-bbp__row ss-bbp__row--skeleton"><span></span><span></span><span></span></div>'; return; }
    if (sr.error) { els.searchStatus.textContent = sr.error; els.searchResults.innerHTML = ''; return; }
    if (!sr.query) { els.searchStatus.textContent = 'Type what the bracelet is for — a hobby, a job, a movie, a feeling — and pick from matching charms.'; els.searchResults.innerHTML = ''; return; }
    if (!sr.items.length) {
      els.searchStatus.textContent = sr.hidden ? 'The charms matching “' + sr.query + '” need a photo or a name, so they can’t join a ready-to-wear set — try another idea.' : 'Nothing for “' + sr.query + '” yet — try another word.';
      els.searchResults.innerHTML = ''; return;
    }
    els.searchStatus.textContent = sr.items.length + (sr.items.length === 1 ? ' charm' : ' charms') + ' for “' + sr.query + '”' + (sr.hidden ? ' · ' + sr.hidden + ' more need a photo or a name (not shown)' : '');
    els.searchResults.innerHTML = '<div class="ss-bbp__row">' + sr.items.map(function (c) { return cardHtml(c, 'search'); }).join('') + '</div>';
  }
  function doSearch(q) {
    q = String(q || '').trim();
    if (!q) return;
    var id = ++state.search.requestId;
    state.search.query = q; state.search.loading = true; state.search.error = '';
    renderSearch();
    var v = visitorId();
    fetchJson(config.search.url, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: q, visitor: v && v.id, scope: v && v.scope, limit: 24 }) })
      .then(function (data) {
        if (id !== state.search.requestId) return;
        state.search.loading = false;
        if (data.status === 'error') { state.search.error = 'Search is taking a break — please try again in a moment.'; state.search.items = []; }
        else { state.search.items = data.items || []; state.search.hidden = Number(data.hidden) || 0; }
        renderSearch();
      })
      .catch(function () { if (id !== state.search.requestId) return; state.search.loading = false; state.search.error = 'Search is taking a break — please try again in a moment.'; renderSearch(); });
  }
  if (els.searchForm) {
    els.searchForm.addEventListener('submit', function (e) { e.preventDefault(); doSearch(els.searchInput.value); els.searchInput.blur(); });
    // rotating example queries while the box is empty and idle
    var samples = (config.search && config.search.samples || []).filter(Boolean), si = 0;
    if (samples.length && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      setInterval(function () {
        if (!state.open || document.activeElement === els.searchInput || els.searchInput.value) return;
        si = (si + 1) % (samples.length + 1);
        els.searchInput.placeholder = si ? 'Try: ' + samples[si - 1] : (config.search.placeholder || '');
      }, 2600);
    }
  }

  // ----- sticky mini preview once the big one scrolls away
  if (els.pin && 'IntersectionObserver' in window) {
    var pinIo = new IntersectionObserver(function (entries) {
      var e = entries[0];
      els.pin.hidden = e.isIntersecting && e.intersectionRatio > 0.12;
    }, { root: els.body, threshold: [0, 0.12, 0.5] });
    pinIo.observe(els.preview);
    els.pin.addEventListener('click', function (ev) {
      if (!ev.target.closest('[data-ss-bbp-pin-up]')) return;
      try { els.body.scrollTo({ top: 0, behavior: 'smooth' }); } catch (err) { els.body.scrollTop = 0; }
    });
  }

  // ----- zoom lightbox
  var lb = { el: els.modal.querySelector('[data-ss-bbp-lb]'), img: els.modal.querySelector('[data-ss-bbp-lb-img]'), name: els.modal.querySelector('[data-ss-bbp-lb-name]'), price: els.modal.querySelector('[data-ss-bbp-lb-price]'), pick: els.modal.querySelector('[data-ss-bbp-lb-pick]'), charm: null, theme: null };
  function findCharm(id, theme) {
    var list = theme === 'search' ? state.search.items : (state.catalog && state.catalog.charms[theme]) || [];
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  }
  function openZoom(id, theme) {
    var charm = findCharm(id, theme); if (!charm || !lb.el) return;
    lb.charm = charm; lb.theme = theme;
    renderZoom();
    lb.el.hidden = false;
    lb.el.querySelector('[data-ss-bbp-lb-close]').focus();
  }
  function renderZoom() {
    if (!lb.charm || lb.el.hidden && !lb.charm) return;
    var pick = findPick(lb.charm.id);
    var mat = pick ? (pick.m || state.braceletMat) : state.braceletMat;
    var names = lb.charm.variants.map(function (v) { return v.m; });
    var eff = materialFor(mat, names);
    var v = null; for (var i = 0; i < lb.charm.variants.length; i++) if (lb.charm.variants[i].m === eff) v = lb.charm.variants[i];
    v = v || lb.charm.variants[0];
    lb.img.style.backgroundImage = 'url(' + JSON.stringify(img(charmImage(lb.charm, eff), 1200)) + ')';
    lb.name.textContent = lb.charm.name;
    lb.price.textContent = money(v.p) + ' · ' + eff;
    lb.pick.textContent = pick ? 'Selected ✓ — tap to remove' : 'Select this charm';
    lb.pick.classList.toggle('is-picked', !!pick);
    lb.pick.setAttribute('data-ss-bbp-pick', lb.charm.id);
    lb.pick.setAttribute('data-theme', lb.theme);
    lb.pick.disabled = !pick && pickCount() >= MAX;
  }
  function closeZoom() { if (lb.el) { lb.el.hidden = true; lb.charm = null; } }

  // ----- open / close
  function open() {
    state.open = true;
    els.modal.hidden = false;
    if (els.pin) els.pin.hidden = true;
    els.body.scrollTop = 0;
    document.body.classList.add('ss-bbp-open');
    load().catch(function () {});
    var x = els.modal.querySelector('.ss-bbp__x'); if (x) x.focus();
  }
  function close() {
    closeZoom();
    state.open = false;
    els.modal.hidden = true;
    document.body.classList.remove('ss-bbp-open');
    var trigger = host.querySelector('[data-ss-bbp-open]'); if (trigger) trigger.focus();
  }

  // ----- add set
  function addSet() {
    if (state.busy || !state.picks.length) return;
    var items = state.picks.map(function (p) { return { id: Number(charmVariant(p).id), quantity: 1 }; });
    var bv = braceletVariant();
    if (bv && !braceletInCart()) items.unshift({ id: Number(bv.id), quantity: 1 });
    state.busy = true; showError(''); renderFooter();
    fetchJson(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
      .then(function () { return fetchJson(root + 'cart.js', { credentials: 'same-origin' }); })
      .then(function (cart) {
        state.cart = cart; state.busy = false; state.picks = [];
        announce(cart);
        close();
        render();
        openDrawer();
      })
      .catch(function (e) { state.busy = false; renderFooter(); showError(e.message || 'Could not add the set — please try again.'); });
  }

  // ----- events
  function onClick(event) {
    var t = event.target.closest('[data-ss-bbp-open],[data-ss-bbp-close],[data-ss-bbp-pick],[data-ss-bbp-add],[data-ss-bbp-zoom],[data-ss-bbp-lb-close],[data-ss-bbp-add-slot],[data-ss-bbp-more]');
    if (!t || !(host.contains(t) || els.modal.contains(t))) return;
    if (t.hasAttribute('data-ss-bbp-open')) { event.preventDefault(); return open(); }
    if (t.hasAttribute('data-ss-bbp-close')) { event.preventDefault(); return close(); }
    if (t.hasAttribute('data-ss-bbp-zoom')) { event.preventDefault(); return openZoom(t.getAttribute('data-ss-bbp-zoom'), t.getAttribute('data-theme')); }
    if (t.hasAttribute('data-ss-bbp-lb-close')) { event.preventDefault(); return closeZoom(); }
    if (t.hasAttribute('data-ss-bbp-more')) { event.preventDefault(); return loadMore(t.getAttribute('data-ss-bbp-more')); }
    if (t.hasAttribute('data-ss-bbp-add-slot')) { event.preventDefault(); if (state.slots.length < MAX_SLOTS) { state.slots.push(null); render(); var ns = els.tiles.querySelector('[data-slot="' + (state.slots.length - 1) + '"] select'); if (ns) { ns.focus(); if (ns.scrollIntoView) ns.scrollIntoView({ block: 'center', behavior: 'smooth' }); } } return; }
    if (t.hasAttribute('data-ss-bbp-add')) { event.preventDefault(); return addSet(); }
    event.preventDefault();
    togglePick(t.getAttribute('data-ss-bbp-pick'), t.getAttribute('data-theme'));
    if (lb.el && !lb.el.hidden) renderZoom();
  }
  function onChange(event) {
    var t = event.target;
    if (!(host.contains(t) || els.modal.contains(t))) return;
    if (t === els.braceletMat) { state.braceletMat = t.value; state.braceletTouched = true; render(); return; }
    if (t.hasAttribute('data-ss-bbp-theme')) {
      var i = Number(t.getAttribute('data-ss-bbp-theme'));
      var h = t.value || null;
      // picks from the theme this tile used to show stay on the bracelet (they are already chosen)
      state.slots[i] = h; render();
      var tile = els.tiles.querySelector('[data-slot="' + i + '"] select'); if (tile) tile.focus();
      // keep the picked-charms view in reach on phones: scroll the new tile's charms into view
      var tileEl = els.tiles.querySelector('[data-slot="' + i + '"]'); if (tileEl && tileEl.scrollIntoView) tileEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    if (t.hasAttribute('data-ss-bbp-charm-mat')) {
      var id = t.getAttribute('data-ss-bbp-charm-mat');
      var pick = findPick(id);
      if (!pick) {
        // not picked yet: choosing a material picks the charm in that material
        togglePick(id, t.getAttribute('data-theme'));
        pick = findPick(id);
      }
      if (pick) {
        pick.m = t.value;
        var card = t.closest('[data-ss-bbp-card]');
        var im = card && card.querySelector('.ss-bbp__card-img');
        if (im) im.style.backgroundImage = 'url(' + JSON.stringify(img(charmImage(pick.charm, charmVariant(pick).m), 300)) + ')';
        var pr = card && card.querySelector('.ss-bbp__card-price');
        if (pr) pr.textContent = money(charmVariant(pick).p);
        render(true);
      }
    }
  }
  host.addEventListener('click', onClick);
  els.modal.addEventListener('click', onClick);
  els.modal.addEventListener('change', onChange);
  document.addEventListener('keydown', function (e) { if (e.key !== 'Escape' || !state.open) return; if (lb.el && !lb.el.hidden) closeZoom(); else close(); });

  // Prefetch so the popup opens full.
  var trigger = host.querySelector('[data-ss-bbp-open]');
  ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) { trigger.addEventListener(ev, function () { load().catch(function () {}); }, { once: true, passive: true }); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) { if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load().catch(function () {}); } });
    io.observe(trigger);
  } else { load().catch(function () {}); }

  // Follow the PDP material until the shopper picks a bracelet material themselves.
  function setMaterialFromVariant(variant) {
    if (state.braceletTouched || !variant) return;
    var mat = '';
    var opts = variant.options || [variant.option1, variant.option2, variant.option3];
    for (var i = 0; i < opts.length; i++) if (opts[i] && /plated|sterling|vermeil|gold|silver/i.test(opts[i])) { mat = opts[i]; break; }
    if (!mat) return;
    config.product.material = mat;
    if (state.bracelet) {
      var names = braceletVariants().map(function (v) { return v.option1 || v.title; });
      state.braceletMat = materialFor(mat, names) || state.braceletMat;
      render();
    }
  }
  try {
    var eventName = (typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) || 'variant-change';
    if (typeof subscribe === 'function') subscribe(eventName, function (e) { var v = e && e.data && e.data.variant; if (v) setMaterialFromVariant(v); });
  } catch (err) { /* no pubsub */ }

  var refreshTimer;
  function onCartEvent(event) {
    var d = event && event.detail;
    if (d && d.source === 'ss-bracelet-popup') return;
    // cart changes only affect prices / promo / bracelet state: never rebuild the charm grid (images would reload)
    if (d && d.cart && Array.isArray(d.cart.items)) { state.cart = d.cart; render(true); return; }
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { fetchJson(root + 'cart.js').then(function (c) { state.cart = c; render(true); }).catch(function () {}); }, 250);
  }
  document.addEventListener('cart:updated', onCartEvent);
  document.addEventListener('soulyshine:cart:updated', onCartEvent);
})();
